// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"62be8bd72ba597240018","71":"fc57de766920d7d7dac8","452":"65ac629301b705f6451c","885":"3e099ff4ebb157ecd72e","961":"8d92c153c987bc9d46a2"}[chunkId] + ".css";
};